const translations = {
  translation: {
    appTitle: 'Einheitenumrechner',
    appDescription: 'Konvertieren Sie Einheiten sofort in 11 verschiedenen Kategorien',
    selectCategory: 'Kategorie auswählen',
    categories: {
      length: 'Länge',
      mass: 'Masse',
      force: 'Kraft',
      energy: 'Energie',
      power: 'Leistung',
      pressure: 'Druck',
      temperature: 'Temperatur',
      time: 'Zeit',
      volume: 'Volumen',
      angle: 'Winkel',
      area: 'Fläche',
    },
    units: {
      meter: 'Meter',
      kilometer: 'Kilometer',
      centimeter: 'Zentimeter',
      millimeter: 'Millimeter',
      micrometer: 'Mikrometer',
      nanometer: 'Nanometer',
      mile: 'Meile',
      yard: 'Yard',
      foot: 'Fuß',
      inch: 'Zoll',
      nauticalMile: 'Seemeile',
      kilogram: 'Kilogramm',
      gram: 'Gramm',
      milligram: 'Milligramm',
      metricTon: 'Tonne',
      pound: 'Pfund',
      ounce: 'Unze',
      ton: 'US-Tonne',
      stone: 'Stone',
      newton: 'Newton',
      kilonewton: 'Kilonewton',
      poundForce: 'Pound-force',
      kilopoundForce: 'Kilopound-force',
      dyne: 'Dyn',
      joule: 'Joule',
      kilojoule: 'Kilojoule',
      calorie: 'Kalorie',
      kilocalorie: 'Kilokalorie',
      wattHour: 'Wattstunde',
      kilowattHour: 'Kilowattstunde',
      electronvolt: 'Elektronenvolt',
      btu: 'BTU',
      footPound: 'Fuß-Pfund',
      watt: 'Watt',
      kilowatt: 'Kilowatt',
      megawatt: 'Megawatt',
      horsepower: 'Pferdestärke',
      btuPerHour: 'BTU/Stunde',
      pascal: 'Pascal',
      kilopascal: 'Kilopascal',
      bar: 'Bar',
      atmosphere: 'Atmosphäre',
      psi: 'PSI',
      torr: 'Torr',
      mmHg: 'mmHg',
      celsius: 'Celsius',
      fahrenheit: 'Fahrenheit',
      kelvin: 'Kelvin',
      second: 'Sekunde',
      millisecond: 'Millisekunde',
      microsecond: 'Mikrosekunde',
      nanosecond: 'Nanosekunde',
      minute: 'Minute',
      hour: 'Stunde',
      day: 'Tag',
      week: 'Woche',
      month: 'Monat',
      year: 'Jahr',
      liter: 'Liter',
      milliliter: 'Milliliter',
      cubicMeter: 'Kubikmeter',
      cubicCentimeter: 'Kubikzentimeter',
      gallon: 'Gallone',
      quart: 'Quart',
      pint: 'Pint',
      cup: 'Tasse',
      fluidOunce: 'Flüssigunze',
      tablespoon: 'Esslöffel',
      teaspoon: 'Teelöffel',
      degree: 'Grad',
      radian: 'Radiant',
      gradian: 'Gon',
      arcminute: 'Bogenminute',
      arcsecond: 'Bogensekunde',
      turn: 'Umdrehung',
      squareMeter: 'Quadratmeter',
      squareKilometer: 'Quadratkilometer',
      squareCentimeter: 'Quadratzentimeter',
      squareMillimeter: 'Quadratmillimeter',
      hectare: 'Hektar',
      acre: 'Acre',
      squareMile: 'Quadratmeile',
      squareYard: 'Quadratyard',
      squareFoot: 'Quadratfuß',
      squareInch: 'Quadratzoll',
    },
    from: 'Von',
    to: 'Zu',
    enterValue: 'Wert eingeben',
    result: 'Ergebnis',
  },
};

export default translations;
